export default "/public/app-main/static/image/a0fcba337db08fdf66b9148a0304ebe8.png";